
interface ContactFormData {
    name: string;
    email: string;
    phone: string;
    message: string;
    turnstileToken: string;
};

export const DEFAULT_CONTACT_FORM_DATA: ContactFormData = {
  name: '',
  email: '',
  phone: '',
  message: '',
  turnstileToken: ''
};

export default ContactFormData;